import dayjs from 'dayjs';
import api from './api';

// วันอาทิตย์หรือวันหยุดบริษัท (/management/holiday) — holidayKeys เป็น Set ของ 'MM-DD' เพราะวันหยุดใช้ซ้ำ
// ทุกปี (convention เดียวกับ resolveLaborDueDate ใน expenses.service.js) เสาร์นับเป็นวันทำงาน
export const isNonWorkingDay = (date, holidayKeys = new Set()) => {
  const d = dayjs(date);
  return d.day() === 0 || holidayKeys.has(d.format('MM-DD'));
};

// วันที่ที่ฟอร์มเพิ่มรายการเบิกกรอกให้อัตโนมัติ (ใช้ร่วมกัน /profile/disbursement กับ /finance/expenses)
// = วันนี้ + offsetDays ถ้าตรงกับวันอาทิตย์/วันหยุด เลื่อนไปข้างหน้าทีละวันจนเจอวันทำงาน
// ฟอร์มสร้างรายการไม่ให้เลือกวันอาทิตย์/วันหยุดเองด้วย (shouldDisableDate ของ ExpensesApplyForm + เช็คตอน submit)
export const getDefaultExpenseDate = (holidayKeys = new Set(), offsetDays = 1) => {
  let d = dayjs().add(offsetDays, 'day');
  while (isNonWorkingDay(d, holidayKeys)) {
    d = d.add(1, 'day');
  }
  return d.toDate();
};

// ดึงวันหยุดบริษัททั้งหมดเป็น Set ของ 'MM-DD' — ดึงตรงผ่าน api ไม่ผ่าน redux state.holiday เพราะหน้าอื่น
// (เช่น AddOtRequest) ใช้ slice นั้นแบบกรองวันเดียว จะเขียนทับกันได้
export const fetchHolidayKeys = async () => {
  const { data } = await api.get(`${process.env.REACT_APP_API_URL}/holiday?size=1000&page=1`);
  return new Set((data?.rows || []).map((h) => dayjs(h.date).format('MM-DD')));
};
